import { NavLink, Outlet, useMatches, useNavigate } from 'react-router-dom';
import { FileText, FileStack, Inbox, Send, Ruler, KeyRound, Webhook, Settings, LogOut } from 'lucide-react';
import { clearToken } from '../lib/auth';

const NAV = [
  { to: '/templates', label: 'Templates', icon: FileText },
  { to: '/documents', label: 'Documents', icon: FileStack },
  { to: '/envelopes', label: 'Envelopes', icon: Inbox },
  { to: '/quick-send', label: 'Quick send', icon: Send },
  { to: '/field-previewer', label: 'Field Previewer', icon: Ruler },
  { to: '/api-keys', label: 'API Keys', icon: KeyRound },
  { to: '/webhooks', label: 'Webhooks', icon: Webhook },
  { to: '/settings', label: 'Settings', icon: Settings },
];

export function DashboardLayout() {
  const navigate = useNavigate();
  // A route opts out of the reading-width column with `handle: { wide: true }`.
  const wide = useMatches().some((m) => (m.handle as { wide?: boolean } | undefined)?.wide);
  return (
    <div className="flex min-h-screen bg-slate-50 font-sans text-slate-900">
      <aside className="flex w-56 flex-col border-r border-slate-200 bg-white">
        <div className="flex items-center gap-2 px-5 py-4">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-brand-600 text-xs font-bold text-white">
            TES
          </div>
          <span className="font-semibold tracking-tight">eSignature</span>
        </div>
        <nav className="flex-1 space-y-1 px-3">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-lg px-3 py-2 text-sm ${
                  isActive ? 'bg-brand-50 font-medium text-brand-700' : 'text-slate-600 hover:bg-slate-100'
                }`
              }
            >
              <Icon size={16} />
              {label}
            </NavLink>
          ))}
        </nav>
        <button
          onClick={() => {
            clearToken();
            navigate('/login');
          }}
          className="m-3 flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-slate-500 hover:bg-slate-100"
        >
          <LogOut size={16} /> Sign out
        </button>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className={wide ? 'px-6 py-6' : 'mx-auto max-w-5xl px-8 py-8'}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
